import {gql, useApolloClient} from "@apollo/client";
import AccountItem from "../../components/login/AccountItem";
import {MutationFunctionOptions, MutationHookOptions} from "@apollo/client/react/types/types";
import {loginUpdateCache} from "./common.graphql";
import {AppAccountFragment, AppUserFragment} from "../../App.graphql";
import React from "react";
import {LoginSession, MutationLoginSelectAccountArgs} from "../../schema";

export const query = gql`
  query AvailableAccountsListQuery {
    accounts: getAvailableAccounts {
      id
      ...AccountItem
    }
  }

  ${AccountItem.fragments.root}
`;

export function useSelectAccountMutation(opts?: MutationHookOptions) {
  const client = useApolloClient();

  const mutate = React.useCallback(
    async (opts: MutationFunctionOptions<{login: LoginSession}, MutationLoginSelectAccountArgs>) => {
      const result = await client.mutate({
        mutation: selectAccountMutation,
        ...opts,
      });

      const loginData = result.data?.login;

      if (loginData) {
        const {user, account} = loginData;

        await client.clearStore();
        loginUpdateCache(client.cache, {user, account: account ?? undefined});
      }

      return result;
    },
    [client],
  );

  return [mutate];
}

const selectAccountMutation = gql`
  mutation LoginSelectAccountMutation($accountId: ID!) {
    login: loginSelectAccount(accountId: $accountId) {
      sessionId
      account {
        id
        ...AppAccount
      }
      user {
        id
        ...AppUser
      }
    }
  }

  ${AppUserFragment}
  ${AppAccountFragment}
`;
